import styled from "styled-components";
import githubIconStatic from "../assets/icons8-github-200.svg";
import githubIcon from "../assets/icons8-github.gif";
import linkedinIconStatic from "../assets/icons8-linkedin-192.svg";
import linkedinIcon from "../assets/icons8-linkedin.gif";
import twitterIconStatic from "../assets/icons8-twitter-192.svg";
import twitterIcon from "../assets/icons8-twitter.gif";

const Footer = () => {
  return (
    <Wrapper>
      <div className="copyright">
        <p> &copy;2022-{new Date().getFullYear()}&nbsp;&nbsp;&nbsp; <span>Abdelghani Mahammedi</span>. All Rights Reserved.</p>
      </div>
      <div className="socials">
        <a
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Github Account"
          href="https://github.com/abdelghanyMh"
          className="socials__link"
          tabIndex="6"
        >
          <img
            width="33.3482px"
            height="33.3482px"
            src={githubIconStatic}
            className="static"
            alt="github account"
          />
          <img
            width="33.3482px"
            height="33.3482px"
            src={githubIcon}
            alt="github account"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Linkedin Account"
          href="https://www.linkedin.com/in/abdelghani-mahammedi-9b329217a/"
          className="socials__link"
          tabIndex="7"

        >
          <img
            src={linkedinIconStatic}
            className="static"
            alt="linkedin account"
            width="33.3482px"
            height="33.3482px"
          />
          <img
            src={linkedinIcon}
            alt="linkedin account"
            width="33.3482px"
            height="33.3482px"
          />
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter Account"
          href="https://twitter.com/abdelghanyMh1"
          className="socials__link"
          tabIndex="8"

        >
          <img
            src={twitterIconStatic}
            className="static"
            alt="twitter account"
            width="33.3482px"
            height="33.3482px"
          />
          <img
            src={twitterIcon}
            alt="twitter account"
            width="33.3482px"
            height="33.3482px"
          />
        </a>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.footer`
  grid-row: footer-start/footer-end;
  grid-column: 1/-1;

  display: flex;
  flex-direction: column-reverse;

  justify-content: space-evenly;
  align-items: center;

  @media (min-width: 1260px) {
    flex-direction: row;
    align-items: flex-end;
  }
  .copyright {
    display: flex;
    gap: 1rem;
  }
  .copyright p {
    font-size: 1.4rem;
    font-weight: normal;
    color: var(--clr-grey-7);
    margin: 0  !important;
    padding: 0 !important;
  }
  .socials {
    display: flex;
    gap: 3.2rem;
  }
  .socials__link {
    width: 4rem;
    padding: 0.5rem;
    border-radius: var(--border-radius);
  }
  .socials__link:hover {
    box-shadow: var(--shadow-1);
  }

  .socials__link > img {
    width: 3rem;
  }
  .static {
    position: absolute;
    background-color: white;
  }
  .socials__link:hover .static {
    opacity: 0;
  }

  @media (max-width: 1260px) {
    margin-top: 5vh;
  }
`;

export default Footer;
